module.exports = __webpack_public_path__ + "img/chart.966d95a9.svg";